import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import {
	UpdateGarageListing,
	AddMedia,
	getCarAgentListing,
} from './../../../../Redux/Actions/UserAction';
import { CarAgentCommonHeader } from './CarAgentCommonHeader';
import Sidebar from '../../../common/Sidebar/Sidebar';
export default function CarsAgentsWorkingHours() {
  const { t } = useTranslation();
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({ mode: 'all' });
	const [CarAgentsData, setCarAgentsDAta] = useState({
		calendar: {
			SUNDAY: {
				status: 'OPEN',
				openTime: '',
				endTime: '',
			},
			MONDAY: {
				status: 'OPEN',
				openTime: '',
				endTime: '',
			},
			TUESDAY: {
				status: 'CLOSE',
			},
			WEDNESDAY: {
				status: 'OPEN',
				openTime: '',
				endTime: '',
			},
			THURSDAY: {
				status: 'OPEN',
				openTime: '',
				endTime: '',
			},
			FRIDAY: {
				status: 'OPEN',
				openTime: '',
				endTime: '',
			},
			SATURDAY: {
				status: 'OPEN',
				openTime: '',
				endTime: '',
			},
		},
	});
	// setMessage(prevState => ({
	// 	input: {
	// 		...prevState.input,
	// 		message: {
	// 			...prevState.input.message,
	// 			text: 'My message',
	// 		},
	// 	},
	// }));

	const handleChange = e => {
		// console.log('e is the id', e.target.id);
		console.log('e is the id', e.target.id);

		// console.log('e is the checked', e.target.checked);

		if (e.target.id === 'SUNDAY') {
			// console.log('e is the best', e.target.id);
			setCarAgentsDAta({
				...CarAgentsData,
				calendar: {
					...CarAgentsData.calendar,
					SUNDAY: {
						...CarAgentsData.calendar.SUNDAY,
						[e.target.name]: e.target.value,
					},
				},
			});
		} else if (e.target.id === 'MONDAY' && e.target.id !== undefined) {
			setCarAgentsDAta({
				...CarAgentsData,
				calendar: {
					...CarAgentsData.calendar,
					MONDAY: {
						...CarAgentsData.calendar.MONDAY,
						[e.target.name]: e.target.value,
					},
				},
			});
		} else if (e.target.id === 'TUESDAY') {
			setCarAgentsDAta({
				...CarAgentsData,
				calendar: {
					...CarAgentsData.calendar,
					TUESDAY: {
						...CarAgentsData.calendar.TUESDAY,
						[e.target.name]: e.target.value,
					},
				},
			});
		} else if (e.target.id === 'WEDNESDAY') {
			setCarAgentsDAta({
				...CarAgentsData,
				calendar: {
					...CarAgentsData.calendar,
					WEDNESDAY: {
						...CarAgentsData.calendar.WEDNESDAY,
						[e.target.name]: e.target.value,
					},
				},
			});
		} else if (e.target.id === 'THURSDAY') {
			setCarAgentsDAta({
				...CarAgentsData,
				calendar: {
					...CarAgentsData.calendar,
					THURSDAY: {
						...CarAgentsData.calendar.THURSDAY,
						[e.target.name]: e.target.value,
					},
				},
			});
		} else if (e.target.id === 'FRIDAY') {
			setCarAgentsDAta({
				...CarAgentsData,
				calendar: {
					...CarAgentsData.calendar,
					FRIDAY: {
						...CarAgentsData.calendar.FRIDAY,
						[e.target.name]: e.target.value,
					},
				},
			});
		} else if (e.target.id === 'SATURDAY') {
			setCarAgentsDAta({
				...CarAgentsData,
				calendar: {
					...CarAgentsData.calendar,
					SATURDAY: {
						...CarAgentsData.calendar.SATURDAY,
						[e.target.name]: e.target.value,
					},
				},
			});
		}
	};
	// function handleChange(e) {
	// 	const { name, value } = e.target;
	// 	setCarAgentsDAta(user => ({ ...user, [name]: value }));
	// }
	const dispatch = useDispatch();

	const home = useSelector(state => state?.home);
	const getMybusiness = home?.getMybusiness;

	// The business id arrives either from Redux (getMybusiness) or from
	// sessionStorage (set by the Header once /business/my resolves). Reading it
	// only once at mount left the form stale after a reload — refetch as soon as
	// the id is known.
	const ownerBid =
		(getMybusiness?.businessId && String(getMybusiness.businessId)) ||
		sessionStorage.getItem('BusinessId');
	const validBid =
		ownerBid && ownerBid !== 'undefined' && ownerBid !== 'null' && ownerBid !== '';

	useEffect(() => {
		if (validBid) {
			dispatch(getCarAgentListing(ownerBid));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ownerBid]);
	const datasubmit = () => {
		// console.log('thsi is the media file ', ImageLogo.sImage)
		alert('this is  data ');
		// console.log(CarAgentsData);
		console.log('tihs is image section', CarAgentsData);
		dispatch(UpdateGarageListing(CarAgentsData));
	};
	const ResetHendler = () => {
		setCarAgentsDAta({
			calendar: {
				SUNDAY: {
					status: 'OPEN',
					openTime: '',
					endTime: '',
				},
				MONDAY: {
					status: 'OPEN',
					openTime: '',
					endTime: '',
				},
				TUESDAY: {
					status: 'CLOSE',
				},
				WEDNESDAY: {
					status: 'OPEN',
					openTime: '',
					endTime: '',
				},
				THURSDAY: {
					status: 'OPEN',
					openTime: '',
					endTime: '',
				},
				FRIDAY: {
					status: 'OPEN',
					openTime: '',
					endTime: '',
				},
				SATURDAY: {
					status: 'OPEN',
					openTime: '',
					endTime: '',
				},
			},
			mediaIds: {
				BANNER: ['77ccadab-b1ed-4b8f-ac67-b68047642049'],
			},
		});
		// setImageLogo ({})
	};

	const sideBarOpt = [
		{
			icon: 'assets/images/icons/sp-business/manage-business.svg',
			link:'/sp-cars-agents-business',
			label: 'Manage Business'
		},
		{
			icon: 'assets/images/icons/sp-business/manage-service.svg',
			link:'/sp-cars-agents-cars',
			label: 'Manage Service'
		},
		{
			icon: 'assets/images/icons/sp-business/banner.svg',
			link:'/sp-cars-agents-banner',
			label: 'Banner'
		},
		{
			icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
			link:'/sp-car-dealers-working-hours',
			label: 'Manage Working Hours'
		},
	]
	return (
		<div>
			<CarAgentCommonHeader/>

			<div class='main-content-area'>
				<div class='container'>
					<div class='row justify-content-between'>
					<Sidebar options={sideBarOpt}/>

						<div class='col-12 col-sm-12 col-md-9 col-lg-9'>
							<h2 class='mb-4'>Manage Working Hours</h2>
							<form onSubmit={handleSubmit(datasubmit)}>
								<div class='mwh-row'>
									<div class='row align-items-center'>
										<div class='col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<div class='mwh-day'>Sunday</div>
										</div>

										<div class='col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<label class='sr-only'>From</label>
											<select
												class='form-control'
												name='openTime'
												id='SUNDAY'
												value={CarAgentsData.openTime}
												onChange={handleChange}>
												<option>{t('From')}</option>
												<option>06:00 am</option>
												<option>07:00 am</option>
												<option>08:00 am</option>
												<option>09:00 am</option>
												<option>10:00 am</option>
												<option>11:00 am</option>
												<option>12:00 pm</option>
												<option>01:00 pm</option>
												<option>02:00 pm</option>
												<option>03:00 pm</option>
												<option>04:00 pm</option>
												<option>05:00 pm</option>
												<option>06:00 pm</option>
												<option>07:00 pm</option>
												<option>08:00 pm</option>
												<option>09:00 pm</option>
												<option>10:00 pm</option>
												<option>11:00 pm</option>
												<option>12:00 am</option>
												<option>01:00 am</option>
												<option>02:00 am</option>
												<option>03:00 am</option>
												<option>04:00 am</option>
												<option>05:00 am</option>
											</select>
										</div>

										<div class='col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<label class='sr-only'>From</label>
											<select
												class='form-control'
												id='SUNDAY'
												name='endTime'
												value={CarAgentsData.endTime}
												onChange={handleChange}>
												<option>{t('To')}</option>
												<option>06:00 am</option>
												<option>07:00 am</option>
												<option>08:00 am</option>
												<option>09:00 am</option>
												<option>10:00 am</option>
												<option>11:00 am</option>
												<option>12:00 pm</option>
												<option>01:00 pm</option>
												<option>02:00 pm</option>
												<option>03:00 pm</option>
												<option>04:00 pm</option>
												<option>05:00 pm</option>
												<option>06:00 pm</option>
												<option>07:00 pm</option>
												<option>08:00 pm</option>
												<option>09:00 pm</option>
												<option>10:00 pm</option>
												<option>11:00 pm</option>
												<option>12:00 am</option>
												<option>01:00 am</option>
												<option>02:00 am</option>
												<option>03:00 am</option>
												<option>04:00 am</option>
												<option>05:00 am</option>
											</select>
										</div>

										<div class='col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<div class='mwh-switch'>
												<div class='form-check form-check-inline'>
													<BootstrapSwitchButton
														width={70}
														// checked={true}
														onstyle='warning'
														onlabel='open'
														offlabel='close'
														name='status'
														id='SUNDAY'
														onChange={handleChange}

														// value={CarAgentsData.status}
													/>
													{/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox1'
														value='option1'
													/> */}
												</div>
											</div>
										</div>
									</div>
								</div>

								{/* <p class='add-more add-more-hours'>
									<a
										class=''
										data-toggle='collapse'
										href='#collapseExample'
										role='button'
										aria-expanded='false'
										aria-controls='collapseExample'>
										Add More +
									</a>
								</p> */}
								<div class='collapse' id='collapseExample'>
									<div class='mwh-row'>
										<div class='row align-items-center'>
											<div class='col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0'>
												<div class='mwh-day'>Sunday</div>
											</div>

											<div class='col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0'>
												<label class='sr-only'>From</label>
												<select
													class='form-control'
													name='openTime'
													id='SUNDAY'
													value={CarAgentsData.openTime}
													onChange={handleChange}>
													<option>{t('From')}</option>
													<option>06:00 am</option>
													<option>07:00 am</option>
													<option>08:00 am</option>
													<option>09:00 am</option>
													<option>10:00 am</option>
													<option>11:00 am</option>
													<option>12:00 pm</option>
													<option>01:00 pm</option>
													<option>02:00 pm</option>
													<option>03:00 pm</option>
													<option>04:00 pm</option>
													<option>05:00 pm</option>
													<option>06:00 pm</option>
													<option>07:00 pm</option>
													<option>08:00 pm</option>
													<option>09:00 pm</option>
													<option>10:00 pm</option>
													<option>11:00 pm</option>
													<option>12:00 am</option>
													<option>01:00 am</option>
													<option>02:00 am</option>
													<option>03:00 am</option>
													<option>04:00 am</option>
													<option>05:00 am</option>
												</select>
											</div>

											<div class='col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0'>
												<label class='sr-only'>From</label>
												<select
													class='form-control'
													id='SUNDAY'
													name='endTime'
													value={CarAgentsData.endTime}
													onChange={handleChange}>
													<option>{t('To')}</option>
													<option>06:00 am</option>
													<option>07:00 am</option>
													<option>08:00 am</option>
													<option>09:00 am</option>
													<option>10:00 am</option>
													<option>11:00 am</option>
													<option>12:00 pm</option>
													<option>01:00 pm</option>
													<option>02:00 pm</option>
													<option>03:00 pm</option>
													<option>04:00 pm</option>
													<option>05:00 pm</option>
													<option>06:00 pm</option>
													<option>07:00 pm</option>
													<option>08:00 pm</option>
													<option>09:00 pm</option>
													<option>10:00 pm</option>
													<option>11:00 pm</option>
													<option>12:00 am</option>
													<option>01:00 am</option>
													<option>02:00 am</option>
													<option>03:00 am</option>
													<option>04:00 am</option>
													<option>05:00 am</option>
												</select>
											</div>

											<div class='col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0'>
												<div class='mwh-switch'>
													<div class='form-check form-check-inline'>
														<BootstrapSwitchButton
															width={70}
															// checked={true}
															onstyle='warning'
															onlabel='open'
															offlabel='close'
															name='status'
															id='SUNDAY'
															onChange={handleChange}

															// value={CarAgentsData.status}
														/>
														{/* <input
															class='form-check-input'
															type='checkbox'
															id='inlineCheckbox1'
															value='option1'
														/> */}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class='mwh-row'>
									<div class='row align-items-center'>
										<div class='col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<div class='mwh-day'>Monday</div>
										</div>

										<div class='col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<label class='sr-only'>From</label>
											<select
												class='form-control'
												name='openTime'
												id='MONDAY'
												value={CarAgentsData.openTime}
												onChange={handleChange}>
												<option>{t('From')}</option>
												<option>06:00 am</option>
												<option>07:00 am</option>
												<option>08:00 am</option>
												<option>09:00 am</option>
												<option>10:00 am</option>
												<option>11:00 am</option>
												<option>12:00 pm</option>
												<option>01:00 pm</option>
												<option>02:00 pm</option>
												<option>03:00 pm</option>
												<option>04:00 pm</option>
												<option>05:00 pm</option>
												<option>06:00 pm</option>
												<option>07:00 pm</option>
												<option>08:00 pm</option>
												<option>09:00 pm</option>
												<option>10:00 pm</option>
												<option>11:00 pm</option>
												<option>12:00 am</option>
												<option>01:00 am</option>
												<option>02:00 am</option>
												<option>03:00 am</option>
												<option>04:00 am</option>
												<option>05:00 am</option>
											</select>
										</div>

										<div class='col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<label class='sr-only'>From</label>
											<select
												class='form-control'
												id='MONDAY'
												name='endTime'
												value={CarAgentsData.endTime}
												onChange={handleChange}>
												<option>{t('To')}</option>
												<option>06:00 am</option>
												<option>07:00 am</option>
												<option>08:00 am</option>
												<option>09:00 am</option>
												<option>10:00 am</option>
												<option>11:00 am</option>
												<option>12:00 pm</option>
												<option>01:00 pm</option>
												<option>02:00 pm</option>
												<option>03:00 pm</option>
												<option>04:00 pm</option>
												<option>05:00 pm</option>
												<option>06:00 pm</option>
												<option>07:00 pm</option>
												<option>08:00 pm</option>
												<option>09:00 pm</option>
												<option>10:00 pm</option>
												<option>11:00 pm</option>
												<option>12:00 am</option>
												<option>01:00 am</option>
												<option>02:00 am</option>
												<option>03:00 am</option>
												<option>04:00 am</option>
												<option>05:00 am</option>
											</select>
										</div>

										<div class='col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<div class='mwh-switch'>
												<div class='form-check form-check-inline'>
													<BootstrapSwitchButton
														width={70}
														// checked={true}
														onstyle='warning'
														onlabel='open'
														offlabel='close'
														name='status'
														id='SUNDAY'
														onChange={handleChange}

														// value={CarAgentsData.status}
													/>
													{/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox2'
														value='option2'
													/> */}
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class='mwh-row'>
									<div class='row align-items-center'>
										<div class='col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<div class='mwh-day'>Tuesday</div>
										</div>

										<div class='col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<label class='sr-only'>From</label>
											<select
												class='form-control'
												name='openTime'
												id='TUESDAY'
												value={CarAgentsData.openTime}
												onChange={handleChange}>
												<option>{t('From')}</option>
												<option>06:00 am</option>
												<option>07:00 am</option>
												<option>08:00 am</option>
												<option>09:00 am</option>
												<option>10:00 am</option>
												<option>11:00 am</option>
												<option>12:00 pm</option>
												<option>01:00 pm</option>
												<option>02:00 pm</option>
												<option>03:00 pm</option>
												<option>04:00 pm</option>
												<option>05:00 pm</option>
												<option>06:00 pm</option>
												<option>07:00 pm</option>
												<option>08:00 pm</option>
												<option>09:00 pm</option>
												<option>10:00 pm</option>
												<option>11:00 pm</option>
												<option>12:00 am</option>
												<option>01:00 am</option>
												<option>02:00 am</option>
												<option>03:00 am</option>
												<option>04:00 am</option>
												<option>05:00 am</option>
											</select>
										</div>

										<div class='col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<label class='sr-only'>From</label>
											<select
												class='form-control'
												id='TUESDAY'
												name='endTime'
												value={CarAgentsData.endTime}
												onChange={handleChange}>
												<option>{t('To')}</option>
												<option>06:00 am</option>
												<option>07:00 am</option>
												<option>08:00 am</option>
												<option>09:00 am</option>
												<option>10:00 am</option>
												<option>11:00 am</option>
												<option>12:00 pm</option>
												<option>01:00 pm</option>
												<option>02:00 pm</option>
												<option>03:00 pm</option>
												<option>04:00 pm</option>
												<option>05:00 pm</option>
												<option>06:00 pm</option>
												<option>07:00 pm</option>
												<option>08:00 pm</option>
												<option>09:00 pm</option>
												<option>10:00 pm</option>
												<option>11:00 pm</option>
												<option>12:00 am</option>
												<option>01:00 am</option>
												<option>02:00 am</option>
												<option>03:00 am</option>
												<option>04:00 am</option>
												<option>05:00 am</option>
											</select>
										</div>

										<div class='col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<div class='mwh-switch'>
												<div class='form-check form-check-inline'>
													<BootstrapSwitchButton
														width={70}
														// checked={true}
														onstyle='warning'
														onlabel='open'
														offlabel='close'
														name='status'
														id='SUNDAY'
														onChange={handleChange}

														// value={CarAgentsData.status}
													/>
													{/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox3'
														value='option3'
													/> */}
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class='mwh-row'>
									<div class='row align-items-center'>
										<div class='col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<div class='mwh-day'>Wednesday</div>
										</div>

										<div class='col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<label class='sr-only'>From</label>
											<select
												class='form-control'
												name='openTime'
												id='WEDNESDAY'
												value={CarAgentsData.openTime}
												onChange={handleChange}>
												<option>{t('From')}</option>
												<option>06:00 am</option>
												<option>07:00 am</option>
												<option>08:00 am</option>
												<option>09:00 am</option>
												<option>10:00 am</option>
												<option>11:00 am</option>
												<option>12:00 pm</option>
												<option>01:00 pm</option>
												<option>02:00 pm</option>
												<option>03:00 pm</option>
												<option>04:00 pm</option>
												<option>05:00 pm</option>
												<option>06:00 pm</option>
												<option>07:00 pm</option>
												<option>08:00 pm</option>
												<option>09:00 pm</option>
												<option>10:00 pm</option>
												<option>11:00 pm</option>
												<option>12:00 am</option>
												<option>01:00 am</option>
												<option>02:00 am</option>
												<option>03:00 am</option>
												<option>04:00 am</option>
												<option>05:00 am</option>
											</select>
										</div>

										<div class='col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<label class='sr-only'>From</label>
											<select
												class='form-control'
												id='WEDNESDAY'
												name='endTime'
												value={CarAgentsData.endTime}
												onChange={handleChange}>
												<option>{t('To')}</option>
												<option>06:00 am</option>
												<option>07:00 am</option>
												<option>08:00 am</option>
												<option>09:00 am</option>
												<option>10:00 am</option>
												<option>11:00 am</option>
												<option>12:00 pm</option>
												<option>01:00 pm</option>
												<option>02:00 pm</option>
												<option>03:00 pm</option>
												<option>04:00 pm</option>
												<option>05:00 pm</option>
												<option>06:00 pm</option>
												<option>07:00 pm</option>
												<option>08:00 pm</option>
												<option>09:00 pm</option>
												<option>10:00 pm</option>
												<option>11:00 pm</option>
												<option>12:00 am</option>
												<option>01:00 am</option>
												<option>02:00 am</option>
												<option>03:00 am</option>
												<option>04:00 am</option>
												<option>05:00 am</option>
											</select>
										</div>

										<div class='col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<div class='mwh-switch'>
												<div class='form-check form-check-inline'>
													<BootstrapSwitchButton
														width={70}
														// checked={true}
														onstyle='warning'
														onlabel='open'
														offlabel='close'
														name='status'
														id='SUNDAY'
														onChange={handleChange}

														// value={CarAgentsData.status}
													/>
													{/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox4'
														value='option4'
													/> */}
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class='mwh-row'>
									<div class='row align-items-center'>
										<div class='col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<div class='mwh-day'>Thursday</div>
										</div>

										<div class='col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<label class='sr-only'>From</label>
											<select
												class='form-control'
												name='openTime'
												id='THURSDAY'
												value={CarAgentsData.openTime}
												onChange={handleChange}>
												<option>{t('From')}</option>
												<option>06:00 am</option>
												<option>07:00 am</option>
												<option>08:00 am</option>
												<option>09:00 am</option>
												<option>10:00 am</option>
												<option>11:00 am</option>
												<option>12:00 pm</option>
												<option>01:00 pm</option>
												<option>02:00 pm</option>
												<option>03:00 pm</option>
												<option>04:00 pm</option>
												<option>05:00 pm</option>
												<option>06:00 pm</option>
												<option>07:00 pm</option>
												<option>08:00 pm</option>
												<option>09:00 pm</option>
												<option>10:00 pm</option>
												<option>11:00 pm</option>
												<option>12:00 am</option>
												<option>01:00 am</option>
												<option>02:00 am</option>
												<option>03:00 am</option>
												<option>04:00 am</option>
												<option>05:00 am</option>
											</select>
										</div>

										<div class='col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<label class='sr-only'>From</label>
											<select
												class='form-control'
												id='THURSDAY'
												name='endTime'
												value={CarAgentsData.endTime}
												onChange={handleChange}>
												<option>{t('To')}</option>
												<option>06:00 am</option>
												<option>07:00 am</option>
												<option>08:00 am</option>
												<option>09:00 am</option>
												<option>10:00 am</option>
												<option>11:00 am</option>
												<option>12:00 pm</option>
												<option>01:00 pm</option>
												<option>02:00 pm</option>
												<option>03:00 pm</option>
												<option>04:00 pm</option>
												<option>05:00 pm</option>
												<option>06:00 pm</option>
												<option>07:00 pm</option>
												<option>08:00 pm</option>
												<option>09:00 pm</option>
												<option>10:00 pm</option>
												<option>11:00 pm</option>
												<option>12:00 am</option>
												<option>01:00 am</option>
												<option>02:00 am</option>
												<option>03:00 am</option>
												<option>04:00 am</option>
												<option>05:00 am</option>
											</select>
										</div>

										<div class='col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<div class='mwh-switch'>
												<div class='form-check form-check-inline'>
													<BootstrapSwitchButton
														width={70}
														// checked={true}
														onstyle='warning'
														onlabel='open'
														offlabel='close'
														name='status'
														id='SUNDAY'
														onChange={handleChange}

														// value={CarAgentsData.status}
													/>
													{/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox5'
														value='option5'
													/> */}
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class='mwh-row'>
									<div class='row align-items-center'>
										<div class='col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<div class='mwh-day'>Friday</div>
										</div>

										<div class='col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<label class='sr-only'>From</label>
											<select
												class='form-control'
												name='openTime'
												id='FRIDAY'
												value={CarAgentsData.openTime}
												onChange={handleChange}>
												<option>{t('From')}</option>
												<option>06:00 am</option>
												<option>07:00 am</option>
												<option>08:00 am</option>
												<option>09:00 am</option>
												<option>10:00 am</option>
												<option>11:00 am</option>
												<option>12:00 pm</option>
												<option>01:00 pm</option>
												<option>02:00 pm</option>
												<option>03:00 pm</option>
												<option>04:00 pm</option>
												<option>05:00 pm</option>
												<option>06:00 pm</option>
												<option>07:00 pm</option>
												<option>08:00 pm</option>
												<option>09:00 pm</option>
												<option>10:00 pm</option>
												<option>11:00 pm</option>
												<option>12:00 am</option>
												<option>01:00 am</option>
												<option>02:00 am</option>
												<option>03:00 am</option>
												<option>04:00 am</option>
												<option>05:00 am</option>
											</select>
										</div>

										<div class='col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<label class='sr-only'>From</label>
											<select
												class='form-control'
												id='FRIDAY'
												name='endTime'
												value={CarAgentsData.endTime}
												onChange={handleChange}>
												<option>{t('To')}</option>
												<option>06:00 am</option>
												<option>07:00 am</option>
												<option>08:00 am</option>
												<option>09:00 am</option>
												<option>10:00 am</option>
												<option>11:00 am</option>
												<option>12:00 pm</option>
												<option>01:00 pm</option>
												<option>02:00 pm</option>
												<option>03:00 pm</option>
												<option>04:00 pm</option>
												<option>05:00 pm</option>
												<option>06:00 pm</option>
												<option>07:00 pm</option>
												<option>08:00 pm</option>
												<option>09:00 pm</option>
												<option>10:00 pm</option>
												<option>11:00 pm</option>
												<option>12:00 am</option>
												<option>01:00 am</option>
												<option>02:00 am</option>
												<option>03:00 am</option>
												<option>04:00 am</option>
												<option>05:00 am</option>
											</select>
										</div>

										<div class='col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<div class='mwh-switch'>
												<div class='form-check form-check-inline'>
													<BootstrapSwitchButton
														width={70}
														// checked={true}
														onstyle='warning'
														onlabel='open'
														offlabel='close'
														name='status'
														id='SUNDAY'
														onChange={handleChange}

														// value={CarAgentsData.status}
													/>
													{/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox6'
														value='option6'
													/> */}
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class='mwh-row'>
									<div class='row align-items-center'>
										<div class='col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<div class='mwh-day'>Saturday</div>
										</div>

										<div class='col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<label class='sr-only'>From</label>
											<select
												class='form-control'
												name='openTime'
												id='SATURDAY'
												value={CarAgentsData.openTime}
												onChange={handleChange}>
												<option>{t('From')}</option>
												<option>06:00 am</option>
												<option>07:00 am</option>
												<option>08:00 am</option>
												<option>09:00 am</option>
												<option>10:00 am</option>
												<option>11:00 am</option>
												<option>12:00 pm</option>
												<option>01:00 pm</option>
												<option>02:00 pm</option>
												<option>03:00 pm</option>
												<option>04:00 pm</option>
												<option>05:00 pm</option>
												<option>06:00 pm</option>
												<option>07:00 pm</option>
												<option>08:00 pm</option>
												<option>09:00 pm</option>
												<option>10:00 pm</option>
												<option>11:00 pm</option>
												<option>12:00 am</option>
												<option>01:00 am</option>
												<option>02:00 am</option>
												<option>03:00 am</option>
												<option>04:00 am</option>
												<option>05:00 am</option>
											</select>
										</div>

										<div class='col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<label class='sr-only'>From</label>
											<select
												class='form-control'
												id='SATURDAY'
												name='endTime'
												value={CarAgentsData.endTime}
												onChange={handleChange}>
												<option>{t('To')}</option>
												<option>06:00 am</option>
												<option>07:00 am</option>
												<option>08:00 am</option>
												<option>09:00 am</option>
												<option>10:00 am</option>
												<option>11:00 am</option>
												<option>12:00 pm</option>
												<option>01:00 pm</option>
												<option>02:00 pm</option>
												<option>03:00 pm</option>
												<option>04:00 pm</option>
												<option>05:00 pm</option>
												<option>06:00 pm</option>
												<option>07:00 pm</option>
												<option>08:00 pm</option>
												<option>09:00 pm</option>
												<option>10:00 pm</option>
												<option>11:00 pm</option>
												<option>12:00 am</option>
												<option>01:00 am</option>
												<option>02:00 am</option>
												<option>03:00 am</option>
												<option>04:00 am</option>
												<option>05:00 am</option>
											</select>
										</div>

										<div class='col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0'>
											<div class='mwh-switch'>
												<div class='form-check form-check-inline'>
													<BootstrapSwitchButton
														width={70}
														// checked={true}
														onstyle='warning'
														onlabel='open'
														offlabel='close'
														name='status'
														id='SUNDAY'
														onChange={handleChange}

														// value={CarAgentsData.status}
													/>
													{/* <input
													class='form-check-input'
													type='checkbox'
													id='inlineCheckbox7'
													value='option7'
												/> */}
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class='row mt-5 '>
									<div class='col-6'>
										<button
											type='reset'
											// onClick={ResetHendler}
											class='btn btn-secondary btn-block'
											href='#'
											onClick={ResetHendler}
											// role='button'
										>
											Reset
										</button>
									</div>
									<div class='col-6'>
										<button
											type='submit'
											// to='/sp-garages-packages'
											class='btn btn-warning btn-block'
											// href='sp-garages-manage-business-packages.html'
											// role='button'
										>
											Submit
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
